import i18next from "i18next";
import { initReactI18next } from "react-i18next";

//Import all translation files
import translationEnglish from "./translation/en.json";
import translationItalian from "./translation/it.json";

//---Using different namespaces
const resources = {
  en: translationEnglish,
  it: translationItalian,
};

const LANGUAGE_STORAGE_KEY = "display-lang";
const supportedLanguages = Object.keys(resources);
const storedLanguage = sessionStorage.getItem(LANGUAGE_STORAGE_KEY);
const initialLanguage =
  storedLanguage && supportedLanguages.includes(storedLanguage)
    ? storedLanguage
    : "it";

i18next.use(initReactI18next).init({
  fallbackLng: "it",
  defaultNS: "it",
  resources,
  lng: initialLanguage,
});

i18next.on("languageChanged", (lng) => {
  sessionStorage.setItem(LANGUAGE_STORAGE_KEY, lng);
});

export default i18next;
